export default "__VITE_ASSET__B3zK8pB7__"